import request from '@services/request';
import Encrypt from '@shared/utils/encodingUtils';
import has from 'lodash/has';

const createCorrespondent = async (correspondent) => {
  const result = await request.post('/api/v1/corresponsal/correspondents', correspondent);
  const { data } = result;
  return data;
};

const updateCorrespondent = async (correspondentId, correspondent) => {
  let body = {};
  delete correspondent.rs;
  delete correspondent.business_name;
  delete correspondent.bass_id;
  if (has(correspondent, 'administrator')) {
    body = {
      ...correspondent,
      administrator: {
        ...correspondent.administrator,
        url_image: correspondent.administrator?.url_image || 'none',
      },
    };
  } else {
    body = correspondent;
  }
  const result = await request.put(`/api/v1/corresponsal/correspondents/${correspondentId}`, body);
  const { data } = result;
  return data;
};

const updateSmallCorrespondent = async (correspondentId, correspondent) => {
  let body = {};
  delete correspondent.rs;
  delete correspondent.business_name;

  body = correspondent;

  const result = await request.put(`/api/v1/corresponsal/correspondents/${correspondentId}`, body);
  const { data } = result;
  return data;
};
const deleteCorrespondent = async (correspondentId) => {
  const result = await request.methodDelete(`/api/v1/corresponsal/correspondents/${correspondentId}`);
  const { data } = result;
  return data;
};

const getCorrespondent = async (page = 1, size = 3, search = {}) => {
  const params = {
    nit: search.nit ?? '',
    name: search.name ?? '',
    corrId: search.corrId ?? null,
    limit: size,
    offset: page,
  };
  const result = await request.get('/api/v1/corresponsal/correspondents', params);
  const { data } = result;
  return data;
};

const getFilteredCorrespondent = async (page = 1, size = 3, search = {}, sorting = {}) => {
  const params = {
    nit: search.nit ?? '',
    business_name: search.business_name ?? '',
    baasId: search.bass_id ?? null,
    limit: size,
    offset: page,
    ...sorting,
  };
  const result = await request.get('/api/v1/corresponsal/filtered-correspondents', params);
  const { data } = result;
  return data;
};

const getCorrespondentTypes = async () => {
  const result = await request.get('/api/v1/corresponsal/correspondents/types');
  const { data } = result;
  return data;
};

const getCorrespondentStatus = async () => {
  const result = await request.get('/api/v1/corresponsal/correspondents/status');
  const { data } = result;
  return data;
};

const permanentClose = async (correspondent) => {
  const body = {
    ...correspondent,
  };
  const result = await request.post('/api/v1/corresponsal/correspondents/permanentClose', body);
  const { data } = result;
  return data;
};

const getCorrespondentSubsidiaries = async (page = 1, size = 3, search = {}, sorting = {}) => {
  const params = {
    bassId: search.bass_id ?? search.subsidiaryId ?? null,
    name: search.name ?? '',
    correspondentId: Encrypt.encode(search.correspondentId) || null,
    status: search.status ?? '',
    address: search.address ?? '',
    limit: size,
    offset: page,
    ...sorting,
  };
  const result = await request.get('/api/v1/corresponsal/subsidiaries/search', params);
  const { data } = result;
  return data;
};

const getAccountBalance = async () => {
  const result = await request.get('api/v1/corresponsal/correspondent/balance');
  const { data } = result;
  return data;
};

const getRegisteredOpenApiCorrespondents = async () => {
  const result = await request.get('api/v1/corresponsal/correspondents/open-api/registered');
  return result.data || {};
};

const getCorrespondentUsers = async (search = {}, page = 0, size = 5) => {
  const params = {
    mail: search.mail ?? '',
    role: search.role || null,
    correspondent: search.correspondent ?? '',
    lastName: search.last_name ?? '',
    limit: size,
    offset: page,
    orderBy: search.orderBy ? search.orderBy : null,
    orderDir: search.orderDir ? search.orderDir : null,
  };
  const result = await request.get('/api/v1/corresponsal/correspondents/users', params);
  const { data } = result;
  return data;
};

const getCorrespondentComissions = async (bassId) => {
  const result = await request.get(`/api/v1/corresponsal/correspondents/${bassId}/commissions`);
  const { data } = result;
  return data;
};

export {
  createCorrespondent,
  deleteCorrespondent,
  getAccountBalance,
  getCorrespondent,
  getCorrespondentComissions,
  getCorrespondentStatus,
  getCorrespondentSubsidiaries,
  getCorrespondentTypes,
  getCorrespondentUsers,
  getFilteredCorrespondent,
  getRegisteredOpenApiCorrespondents,
  permanentClose,
  updateCorrespondent,
  updateSmallCorrespondent,
};
